module.exports = __webpack_public_path__ + "img/zip.b102642c.svg";